import React, { useRef, useEffect, useMemo } from 'react';
import { Layout, Tabs } from 'tea-component';
import { history, useIntl, connect, useDispatch } from 'umi';
import { arrayToSimpleObj } from '../../utils';
import UserGuideFeeds from '@op/components/UserGuide/feeds';
import useTabs from './hooks/useTabs';
import { storage } from '@/utils/utils';
import { OPINION_GUIDE_BOX_LIST2 } from '@/pages/home/components/GuideModule/GuideOpinionBox';
import { GUIDE_TYPE_OPINION_FEEDS } from '@/pages/home/models/guide';
import ContentBody from '../../components/ContentBody';
import '@/pages/opinion/assets/scss/pages/feeds/index.scss';
import classnames from 'classnames';
import { PAGE_NAME } from '@op/constants/page';
import CardCommon from '@op/components/CardCommon';
import useTabHistory from '@op/hooks/useTabHistory'; 

const { Content } = Layout;
const whiteList = ['/opinion/Feeds/Feeds', '/opinion/Feeds/Feeds/Details'];
const Feeds = ({ gameInfo, userInfo, location, wholeGameInfo }: any) => {
  const ref = useRef(null);
  const { formatMessage } = useIntl();
  // 使用 match 的形式
  const tabId = location?.query?.tab || 'socialMedia';
  const dispatch = useDispatch();

  useEffect(() => {
    const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST2) || [];
    if (userInfo?.openid && !list.includes(userInfo.openid)) {
      dispatch({
        type: 'guide/save',
        payload: {
          guideSys: '',
          guideType: GUIDE_TYPE_OPINION_FEEDS,
        },
      });
    }
  }, [userInfo]);

  const { tabs } = useTabs({ gameInfo, wholeGameInfo, tabId });

  const titleOperationMap = arrayToSimpleObj(tabs, 'titleOperation', 'id');

  history.block((location) => {
    const flag = whiteList.some((item) => location.pathname.includes(item));
    // 每次路由变动都会走这里
    if (!flag) {
      sessionStorage.removeItem(
        `feedsGameStore_${gameInfo.edition_unified_id}`,
      );
      sessionStorage.removeItem(
        `feedsSocialMedia_${gameInfo.edition_unified_id}`,
      );
    }
  });

  const { onActive, tab } = useTabHistory({
    defaultValue: tabId,
    removeKeys: ['shortid'],
  });

  // const [activeId, setActiveId] = useState(tabId);

  // const onActive = (tabInfo: { id: any }) => {
  //   const { query } = location;
  //   setActiveId(tabInfo.id);
  //   const { tab, ...otherInfo } = query || {};
  //   const url = objToUrl(otherInfo);
  //   history.replace(`/opinion/Feeds/Feeds?tab=${tabInfo.id}&${url}`);
  // };

  const renderElement = useMemo(
    () => tabs?.filter((val) => val.id === tab)[0],
    [tab, tabs],
  );

  return (
    <Content ref={ref} className="dbo-page dbo-feeds">
      <ContentBody
        contentHeard={
          <Content.Header
            title={formatMessage({ id: PAGE_NAME.FEEDS })}
            className={`dbo-header ${tabs.length !== 0 ? 'contentHead-normal' : ''
              }`}
            subtitle={titleOperationMap[tab] || null}
          >
            {tabs.length !== 0 && (
              <div className="header-tab feeds-header-tab">
                <Tabs
                  ceiling
                  tabs={tabs}
                  animated={false}
                  activeId={tab}
                  onActive={onActive}
                />
              </div>
            )}
          </Content.Header>
        }
      // TODO: 暂时隐藏跑马灯
      // horseRaceLampTips={
      //   DBO_GAME.isNormal(wholeGameInfo) ? normalTranslateTipsText : undefined
      // }
      >
        <CardCommon contentCard loading={tabs.length === 0} loadingHeight={550}>
          <div
            key={renderElement?.id}
            className={classnames(renderElement?.className)}
          >
            {renderElement?.component}
          </div>
        </CardCommon>
      </ContentBody>

      <UserGuideFeeds></UserGuideFeeds>
    </Content>
  );
};

export default connect((state: any) => {
  const { opinionCommon, home } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    userInfo: home.userInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(Feeds);
